export default class AdminLogs {
  axiosIns = null
  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  list(log_type, params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminLogsEndpoint}/${log_type}`, {
      params
    })
  }

  export(log_type, params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminLogsEndpoint}/${log_type}/export`, {
      params,
      responseType: "blob"
    });
  }
}
